import {FC} from 'react'
import {Button, Card} from 'react-bootstrap'
import {SimulationResponse} from '../core/_models'

type Props = {result: SimulationResponse; reporterName: string; onBackToForm: () => void}

const SimulationNotes: FC<Props> = ({result, reporterName, onBackToForm}) => {
  const flows = result.meta.counter_calc_trade_creation_not_null || 0
  const economies = Object.keys(result.partners_affected.trade_creation || {}).length

  return (
    <Card className='mb-5'>
      <Card.Header className='card-header-stretch'>
        <Card.Title>
          <h3>Notes on the simulation</h3>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <p>
          This simulation estimates the impact on {reporterName} of losing the selected preferential
          tariff treatment, affecting {flows} commodity flows across {economies} trade partners.
          Results reflect a partial-equilibrium trade-policy model (trade creation, trade diversion,
          and second-degree diversion).
        </p>
        <p className='text-muted'>
          Methodology: UNCTAD TPA Vol.1 Ch.2A/Ch.4. Trade diversion is capped at 100% of current
          import value. Figures are estimates and should be interpreted as orders of magnitude.
        </p>
        <Button className='btn btn-warning btn-sm fw-bold text-black' onClick={onBackToForm}>
          <i className='bi bi-arrow-left me-2 text-black'></i>Back to form
        </Button>
      </Card.Body>
    </Card>
  )
}

export default SimulationNotes
